import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReceivementFollowUpRequestModel } from '../../models/conference/receivement-follow-up-request.model';
import { ReceivementFollowUpResponseModel } from '../../models/conference/receivement-follow-up-response.model';
import { ReceivementConferenceRequestModel } from 'src/app/wings-mobile/models/conference/receivement-conference-request.model';

@Injectable({
	providedIn: 'root'
})
export class ReceivementConferenceService {

	constructor(private http: HttpClient) {
		this.http = http;
	}

	httpOptions = { headers: new HttpHeaders({ 'Content-type': 'application/json' }) };

	postFind(request: ReceivementFollowUpRequestModel): Observable<ReceivementFollowUpResponseModel[]> {
		const URL = environment.inbound_url + '/api/v1/receiving-follow-up/find';
		return this.http.post<ReceivementFollowUpResponseModel[]>(URL, request);
	}

	putConference(request: ReceivementConferenceRequestModel) {
		const URL = environment.inbound_url + '/api/v1/receiving-follow-up/conference';
		return this.http.put<any>(URL, request);
	}
}

